import { OtsAircraft } from "../App/Models/OtsAircraft";
import { getHoursOpen } from "../OpenEvents/RealTimeHoursOpen";
import { EventTypeFilter } from "../../Models/EventTypeFilter";
import { EventType} from "../../Models/EventType";

function sortListByAircraft(otsAircraft?: OtsAircraft[], clickCount?: number) {
  if (!otsAircraft) {
    return [];
  }

  const aircraftCopy = [...otsAircraft];

  if (clickCount === 1) {
    return aircraftCopy.sort((a, b) => {
      if( a.EventType === b.EventType){
        const airlineA = a.AircraftRegistration;
        const airlineB = b.AircraftRegistration;

        const isAirbusA = airlineA.slice(-2) === "VA";
        const isAirbusB = airlineB.slice(-2) === "VA";

        // Prioritize Boeing over Airbus
        if (isAirbusA !== isAirbusB) {
          return isAirbusA ? 1 : -1;
        }
        // If both are the same type, sort in ascending alphanumeric order
        return airlineA < airlineB ? -1 : 1;
    } else {
        // Else sort by EventType
        return a.EventType.localeCompare(b.EventType);
    }
    });
    
  } else if (clickCount === 2) {
    return aircraftCopy.sort((a, b) => {
       if( a.EventType === b.EventType){
      const airlineA = a.AircraftRegistration;
      const airlineB = b.AircraftRegistration;

      const isAirbusA = airlineA.slice(-2) === "VA";
      const isAirbusB = airlineB.slice(-2) === "VA";

      // Prioritize Boeing over Airbus
      if (isAirbusA !== isAirbusB) {
        return isAirbusA ? 1 : -1;
      }

      return airlineA > airlineB ? -1 : 1;
    } else { 
        return a.EventType.localeCompare(b.EventType);
    }
    });
  } else {
    return otsAircraft;
  }
}

function sortListByAircraftOnly(otsAircraft?: OtsAircraft[], clickCount?: number) {
  if (!otsAircraft) {
    return [];
  }

  const aircraftCopy = [...otsAircraft];

  if (clickCount === 1) {
    return aircraftCopy.sort((a, b) => {
        const airlineA = a.AircraftRegistration;
        const airlineB = b.AircraftRegistration;

        const isAirbusA = airlineA.slice(-2) === "VA";
        const isAirbusB = airlineB.slice(-2) === "VA";

        // Prioritize Boeing over Airbus
        if (isAirbusA !== isAirbusB) {
          return isAirbusA ? 1 : -1;
        }
        // If both are the same type, sort in ascending alphanumeric order
        return airlineA < airlineB ? -1 : 1;
    });
    
  } else if (clickCount === 2) {
    return aircraftCopy.sort((a, b) => {
      const airlineA = a.AircraftRegistration;
      const airlineB = b.AircraftRegistration;

      const isAirbusA = airlineA.slice(-2) === "VA";
      const isAirbusB = airlineB.slice(-2) === "VA";

      // Prioritize Boeing over Airbus
      if (isAirbusA !== isAirbusB) {
        return isAirbusA ? 1 : -1;
      }

      return airlineA > airlineB ? -1 : 1;
    });
  } else {
    return otsAircraft;
  }
}

function sortByStation(otsAircraft?: OtsAircraft[], clickCount?: number) {
  if (!otsAircraft) {
    return [];
  }

  const aircraftCopy = [...otsAircraft];

  if (clickCount === 1) {
    return aircraftCopy.sort((a, b) => {
         if (a.EventType === b.EventType) {
        const stationA = a.Station;
        const stationB = b.Station;

        return stationA < stationB ? -1 : 1;
      }
      else {
        return a.EventType.localeCompare(b.EventType);
      }
    });
  } else if (clickCount === 2) {
    return aircraftCopy.sort((a, b) => {
      if (a.EventType === b.EventType) {
      const stationA = a.Station;
      const stationB = b.Station;
      return stationA > stationB ? -1 : 1;
      }
      else {
        return a.EventType.localeCompare(b.EventType);
      }
    });
  } else {
    return otsAircraft;
  }
}
function sortByStationOnly(otsAircraft?: OtsAircraft[], clickCount?: number) {
  if (!otsAircraft) {
    return [];
  }

  const aircraftCopy = [...otsAircraft];

  if (clickCount === 1) {
    return aircraftCopy.sort((a, b) => {
        const stationA = a.Station;
        const stationB = b.Station;

        return stationA < stationB ? -1 : 1;
    });
  } else if (clickCount === 2) {
    return aircraftCopy.sort((a, b) => {
      
      const stationA = a.Station;
      const stationB = b.Station;
      return stationA > stationB ? -1 : 1;
    });
  } else {
    return otsAircraft;
  }
}

function sortListByAdvDate( otsAircraft: OtsAircraft[], clickCount?: number) 
{
  const aircraftData = [...otsAircraft];
  return aircraftData.sort((a, b) => {
      const dateA = a.AdviseTimeUTC;
      const dateB = b.AdviseTimeUTC;
      return clickCount == 1
        ? a.EventType === b.EventType ? sortDateAscending(dateA, dateB) : a.EventType.localeCompare(b.EventType)
        : clickCount == 2
        ? a.EventType === b.EventType ? sortDateDescending(dateA, dateB) : a.EventType.localeCompare(b.EventType)
        : otsAircraft;
  });   
}

function sortListByEtrDate( otsAircraft: OtsAircraft[], clickCount?: number) 
{
  const aircraftData = [...otsAircraft];
  return aircraftData.sort((a, b) => {
      const dateA = a.EstimatedReturnToServiceTimeUTC;
      const dateB = b.EstimatedReturnToServiceTimeUTC;
      return clickCount == 1
        ? a.EventType === b.EventType ? sortDateAscending(dateA, dateB) : a.EventType.localeCompare(b.EventType)
        : clickCount == 2
        ? a.EventType === b.EventType ? sortDateDescending(dateA, dateB) : a.EventType.localeCompare(b.EventType)
        : otsAircraft;
  });   
}

function sortListByEtdDate( otsAircraft: OtsAircraft[], clickCount?: number) 
{
  const aircraftData = [...otsAircraft];
  return aircraftData.sort((a, b) => {
      const dateA = a.SETD;
      const dateB = b.SETD;
      return handleCountClick(a, b, dateA, dateB, clickCount);
  });   
}

const handleCountClick=(a:any, b:any, dateA:any, dateB:any,clickCount:any)=>{
    if (clickCount == 1) {
    if (a.EventType === b.EventType) {
        return sortDateAscending(dateA, dateB);
    } else {
        return a.EventType.localeCompare(b.EventType);
    }
} else if (clickCount == 2) {
    if (a.EventType === b.EventType) {
        return sortDateDescending(dateA, dateB);
    } else {
        return a.EventType.localeCompare(b.EventType);
    }
} else {
    return otsAircraft;
}

}

  function sortDateAscending(dateA: any, dateB: any) {
    if (dateA === null) {
      return 1;
    }

    if (dateB === null) {
      return -1;
    }

    if (dateA === dateB) {
      return 0;
    }

    return dateA < dateB ? -1 : 1;
  }
  function sortDateDescending(dateA: string, dateB: string) {
    if (dateA === null) {
      return 1;
    }

    if (dateB === null) {
      return -1;
    }

    if (dateA === dateB) {
      return 0;
    }

    return dateA > dateB ? -1 : 1;
  }


function _sortByHoursOpen(otsAircraft?: OtsAircraft[], clickCount?: number) {
  if (!otsAircraft) {
    return [];
  }

  const aircraftCopy = [...otsAircraft];

  if (clickCount === 1) {
    return aircraftCopy.sort((a, b) => {
      if (a.EventType === b.EventType) {
      const { duration: durationA } = getHoursOpen( a.OutOfServiceDateTimeUTC);
      const { duration: durationB }  = getHoursOpen(b.OutOfServiceDateTimeUTC);

      return durationB.asMilliseconds() - durationA.asMilliseconds();
      } 
      else {
        return a.EventType.localeCompare(b.EventType);
      }
    });
  } else if (clickCount === 2) {
    return aircraftCopy.sort((a, b) => {
      if (a.EventType === b.EventType){
        const { duration: durationA } = getHoursOpen( a.OutOfServiceDateTimeUTC);
        const { duration: durationB }  = getHoursOpen(b.OutOfServiceDateTimeUTC);
  
        return durationA.asMilliseconds() - durationB.asMilliseconds();
      } 
      else {
        return a.EventType.localeCompare(b.EventType);
      }
    });
  } else {
    return otsAircraft;
  }
}
function _sortByHoursOpenOnly(otsAircraft?: OtsAircraft[], clickCount?: number) {
  if (!otsAircraft) {
    return [];
  }

  const aircraftCopy = [...otsAircraft];

  if (clickCount === 1) {
    return aircraftCopy.sort((a, b) => {
      const { duration: durationA } = getHoursOpen( a.OutOfServiceDateTimeUTC);
      const { duration: durationB }  = getHoursOpen(b.OutOfServiceDateTimeUTC);

      return durationB.asMilliseconds() - durationA.asMilliseconds();
    });
  } else if (clickCount === 2) {
    return aircraftCopy.sort((a, b) => {
      const { duration: durationA } = getHoursOpen( a.OutOfServiceDateTimeUTC);
      const { duration: durationB }  = getHoursOpen(b.OutOfServiceDateTimeUTC);

      return durationA.asMilliseconds() - durationB.asMilliseconds();
    });
  } else {
    return otsAircraft;
  }
}

export function FilterOpenEvents(
  eventTypeFilters?: EventTypeFilter[],
  otsAircraft?: OtsAircraft[]
){
  if (!otsAircraft) {
    return [];
  }
  if(!eventTypeFilters || eventTypeFilters.length === 0){
      return otsAircraft;
  }

  let filteredAircraft;
  // apply filters 
  filteredAircraft = otsAircraft.filter((aircraft) => {
    return eventTypeFilters?.some((filter) => {
      return filter.Name === aircraft.EventType && filter.IsChecked;
    });
  });
  return filteredAircraft || [];
}

export function SortOtsCards(
  eventTypeFilters?: EventTypeFilter[],
  otsAircraft?: OtsAircraft[],
  selectedField?: string,
  clickCount?: number
) {
  console.log("SortOtsCards eventTypeFilters: ", eventTypeFilters);
  let sortedAircraft;
   if (!otsAircraft) {
    return [];
   }
   let filteredAircraft;
   // apply filters 
    if (eventTypeFilters && eventTypeFilters.length > 0) {
       filteredAircraft = otsAircraft.filter((aircraft) => {
        return eventTypeFilters.some((filter) => {
          return filter.Name === aircraft.EventType && filter.IsChecked;
        });
      });
    } else { 
      filteredAircraft = otsAircraft;
    }

    console.log("ots aircraft with filters applied: ", filteredAircraft)
  switch (selectedField) {
    case "Aircraft #":
      sortedAircraft = sortListByAircraft(filteredAircraft, clickCount);
      break;
    case "Station":
      sortedAircraft = sortByStation(filteredAircraft, clickCount);
      break;
    case "ADV":
      sortedAircraft = sortListByAdvDate(filteredAircraft, clickCount);
      break;
    case "ETR":
      sortedAircraft = sortListByEtrDate(filteredAircraft, clickCount);
      break;
    case "ETD":
      sortedAircraft = sortListByEtdDate(filteredAircraft, clickCount);
      break;
    case "Hours Open":
      sortedAircraft = _sortByHoursOpen(filteredAircraft, clickCount);
      break;
    default:
      sortedAircraft = otsAircraft;
      break;
  }
  return sortedAircraft || [];
}

export function SortOtsClosedEventsCards(
  otsAircraft?: OtsAircraft[],
  selectedField?: string,
  clickCount?: number
) {
  let sortedAircraft;

  switch (selectedField) {
    case "Aircraft #":
      sortedAircraft = sortListByAircraftOnly(otsAircraft, clickCount);
      break;
    case "Station":
      sortedAircraft = sortByStationOnly(otsAircraft, clickCount);
      break;
    case "OTS start time":
      sortedAircraft = _sortByHoursOpenOnly(otsAircraft, clickCount);
      break;
    default:
      sortedAircraft = otsAircraft;
      break;
  }
  return sortedAircraft || [];
}

export function SortByHoursOpen(otsaircraft: OtsAircraft[]){
  if (!otsaircraft) {
    return [];
  }
  // dashboard sort is 
  console.log("sorting ots aircraft: ", otsaircraft);
  return otsaircraft;
};

export function setDragAndDropOrder(
  otsAircraft: OtsAircraft[],
  viewableEventTypes: EventType[],
  dragAndDropEventList: string[]
){
  //set as per drag and drop, ignore locked events
  let listCopy = [...otsAircraft];
  // Creating a new list that includes the locked event types
  let newList = listCopy.filter(ac => viewableEventTypes.find(evt => evt.Name === ac.EventType && evt.IsLocked));
  // Including the event types in dragAndDropEventList order, but only if they are not locked
  newList.push(...dragAndDropEventList.flatMap((eventType: any) => 
    listCopy.filter(ac => ac.EventType === eventType && !viewableEventTypes.some(evt => evt.Name === ac.EventType && evt.IsLocked))
  ));
  // Including the remaining event types if any
  newList.push(...listCopy.filter(ac => !newList.some(newAc => newAc.EventType === ac.EventType)));
  return newList;
}
